import {useHistory} from 'react-router-dom';

import {useOpenApiFpRequest} from '../Http/useOpenApiRequest';
import useAuth from '../utils/AuthContext';
import {AuthorizeApi, UserApi} from '../scaffold';

export default function useCheckAuth() {
  const auth = useAuth();
  const history = useHistory();
  const checkRequest = useOpenApiFpRequest(AuthorizeApi, AuthorizeApi.prototype.authorizeCheckGet);

  function logout() {
    auth.logout();
    localStorage.removeItem('Application-Token');
  }

  return {
    logout: logout,
    isChecking: checkRequest.loading,
    check: async () => {
      // wait
      const localToken = localStorage.getItem('Application-Token');
      if (localToken) {
        auth.setToken(localToken);
      }
      if (!localToken) {
        logout();
      } else {
        checkRequest
          .request({token: localToken})
          .then(i => auth.setCurrentUser(i))
          .catch(e => logout());
      }
    },
  };
}
